// General
import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';

import ReviewRating from '../../components/Reviews/Rating';
import NotFound from '../notFound/NotFound';

import WriteReviewDataQuery from './WriteReviewData.graphql';
import { withQuery } from '../../hoc/withGraphql';

import s from './WriteReview.css';

const WriteReview = (props) => {

  const { writeReview, writeReview: { writeReviewData, loading }, title } = props;
  if (!loading && !writeReviewData) {
    return <NotFound title={title} />
  }
  return (
    <>
      {!loading &&
        <div className={s.root}>
          <div className={s.container}>
            <ReviewRating data={writeReview} />
          </div>
        </div>}
    </>
  );
}

WriteReview.propTypes = {
  reservationId: PropTypes.number.isRequired,
  writeReview: PropTypes.shape({
    loading: PropTypes.bool,
    writeReviewData: PropTypes.object
  }),
};

export default compose(
  withStyles(s),
  withQuery(WriteReviewDataQuery,
    {
      name: 'writeReview',
      options: (props) => ({
        variables: {
          reservationId: props.reservationId,
        },
        fetchPolicy: 'network-only',
        ssr: false
      })
    }
  ),
)(WriteReview);
